// extracted by mini-css-extract-plugin
export default {"item":"TopCountries_item__M62xv","flag":"TopCountries_flag__GodIH","price":"TopCountries_price__JXurv"};